import React from 'react';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';


// OkasBoxes warranty page 
export default class WarrantyOkasBox extends React.Component{
    state ={
        error: ''
    }

    render(){
        return (
           <React.Fragment>
                     <div style={{width: '80vw',}}>
      <div className="si-list col-12">
      <div className="d-flex justify-content-between">
      <div className="col-4 pl-0 pb-2">
                      {/* <SearchBar  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  /> */}
                                 <h3 className="ai-heading dashboard-ai-heading">WARRANTY STATUS </h3>       
                     </div>
              </div>
          <table className="table">
            <thead className="tableHeaderColor" style={{borderRadius: '10px 10px 0px 0px'}}>            
                <th scope="col" style={{width: '5%'}}>ID</th>
                <th scope="col" style={{width: '15%'}}>Box Type</th>
                <th scope="col" style={{width: '20%'}}>Serial No</th>
                <th scope="col" style={{width: '15%'}}>Registration ID</th>
                <th scope="col" style={{width: '15%'}}>License</th>
                <th scope="col" style={{width: '10%'}}>Status</th>                            
            </thead>
            <tbody style={{height: '45vh'}}>
               {/* {this.obDatatable()} */}
            </tbody>
          </table>
    </div>
  </div>   
           </React.Fragment>
        )
    }
}